import React from 'react';
import KomunikatI from '../../assets/GISwNauce_Komunikat_I_2026.pdf';

import './main.css';

const Main = () => {
  return (
    <div className="giswnauce__main">
      <span className="anchor-main" id="giswnauce_main"></span>
      <div className="giswnauce__main-content">
        <div className="content-description">
          <h1>XII Edycja Ogólnopolskiej Konferencji GIS w&nbsp;nauce</h1>
          <h2>Szanowni Państwo!</h2>
          <p>
          Serdecznie zapraszamy do udziału w&nbsp;XII edycji Ogólnopolskiej Konferencji <b>GIS w&nbsp;Nauce</b>,
          która odbędzie się w&nbsp;dniach <b>24&nbsp;-&nbsp;25 września 2026 roku</b> na <b>Uniwersytecie Warmińsko-Mazurskim w&nbsp;Olsztynie</b>.
          Konferencja organizowana jest przez <b>Instytut Gospodarki Przestrzennej i&nbsp;Geografii</b>&nbsp; 
          pod patronatem <b>Komitetu Nauk Geograficznych Polskiej Akademii Nauk</b>. 
          </p>
          <p>
          Konferencja <i>GIS w&nbsp;Nauce</i> od lat stanowi istotne forum integrujące środowisko naukowe zajmujące się systemami informacji geograficznej, 
          geoinformacją oraz geoinformatyką. Wydarzenie skupia przedstawicieli różnych dyscyplin naukowych, 
          umożliwiając wymianę idei, doświadczeń oraz wyników badań związanych z zastosowaniem technologii GIS w&nbsp;naukach 
          ścisłych, przyrodniczych, technicznych i&nbsp;humanistycznych.
          </p>
          <p>
          Głównym celem konferencji jest prezentacja najnowszych osiągnięć naukowych w obszarze systemów informacji geograficznej oraz 
          stworzenie przestrzeni do merytorycznej dyskusji nad szerokim spektrum ich zastosowań badawczych i praktycznych. 
          Wydarzenie stanowi również doskonałą okazję do spotkania przedstawicieli środowiska naukowego, 
          wymiany poglądów oraz nawiązania nowych form współpracy.
          </p>
          <p>
          Program konferencji obejmuje <b>sesje plenarne, referaty tematyczne, sesje posterowe oraz warsztaty praktyczne</b>, 
          umożliwiające pogłębienie wiedzy i rozwój kompetencji w zakresie nowoczesnych narzędzi i metod GIS. 
          Tegoroczna edycja, kontynuując wieloletnią tradycję konferencji, po raz pierwszy odbędzie 
          się w&nbsp;Olsztynie&nbsp;–&nbsp;mieście akademickim o&nbsp;silnych tradycjach naukowych i&nbsp;dynamicznie rozwijającym się zapleczu badawczym.
          </p>
          <p>
          Pierwsza konferencja <i>GIS w Nauce</i>, zainicjowana w <b>2012 roku</b> przez prof.&nbsp;Iwonę&nbsp;Jażdżewską oraz prof.&nbsp;Jacka&nbsp;Urbańskiego, 
          odbyła się na Uniwersytecie Łódzkim. Od tego czasu wydarzenie cieszy się nieustannie rosnącym zainteresowaniem środowiska naukowego. 
          Do udziału zapraszamy zarówno doświadczonych badaczy, jak i młodych naukowców rozpoczynających swoją działalność naukową.
          </p>
          <p>
          Zachęcamy do śledzenia aktualnych informacji na stronie internetowej konferencji oraz do rejestracji uczestnictwa. 
          Mamy nadzieję, że spotkamy się licznie w <b>Olsztynie</b>, aby wspólnie kontynuować tradycję konferencji <i>GIS w Nauce</i> i przyczynić się do dalszego rozwoju badań nad systemami informacji geograficznej.
          </p>
          <a href={ KomunikatI } target="_blank" rel="noreferrer"><h3>
          KOMUNIKAT I
          </h3></a>
        </div>
      </div>
    </div>
  )
}

export default Main